
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import DataTableComponent from '@/components/DataTableComponent.vue';
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate';
import { required } from 'vee-validate/dist/rules';
import { departureStore, reestruturacaoOcorrenciaStore } from '@/store';
import {
  IReestruturacaoOcorrencia,
  IReestruturacaoOcorrenciaCreate,
  IReestruturacaoOcorrenciaUpdate,
} from '@/interfaces/reestruturacaoOcorrencia';

extend('required', { ...required, message: '{_field_} deve ser preenchido!' });

@Component({
  components: {
    DataTableComponent,
    ValidationObserver,
    ValidationProvider,
  },
})
export default class Ocorrencias extends Vue {
  @Prop({ type: Number, required: true }) readonly propCompanyId;

  @Watch('propCompanyId', { immediate: true })
  public async reload1(companyId) {
    this.companyId = companyId;
    this.load();
  }

  public loading = false;
  public loadingActionSubmit = false;

  public id = 0;
  public companyId = 0;
  public tipoContato = '';
  public departureId = 0;
  public objetivoId = 0;
  public dataProximoContato = '';
  public observacao = '';

  public criadoPor = '';
  public criadoEm = '';

  public statusColors = {
    Resolvido: '#a5d6a7',
    'A Resolver': '#f99090',
  };

  public objetivos = [
    { id: 1, label: ' Atingido' },
    { id: 2, label: ' Atingido com ressalva' },
    { id: 3, label: ' Fracasso no contato' },
  ];

  public headerOcorrencia = [
    {
      text: 'Tipo do contato',
      sortable: true,
      value: 'tipo_contato',
      align: 'left',
    },
    {
      text: 'Departamento',
      sortable: true,
      value: 'departure_name',
      align: 'left',
    },
    {
      text: 'Objetivo',
      sortable: true,
      value: 'objetivo',
      align: 'left',
    },
    {
      text: 'Observação',
      sortable: true,
      value: 'observacao',
      align: 'left',
    },
    {
      text: 'Data do próximo contato',
      sortable: true,
      value: 'data_proximo_contato',
      align: 'left',
    },
    {
      text: 'Criado por',
      sortable: true,
      value: 'full_name',
      align: 'left',
    },
    {
      text: 'Criado em',
      sortable: true,
      value: 'created_at',
      align: 'left',
    },
    {
      text: 'Ação executada',
      sortable: true,
      value: 'actions',
      align: 'left',
    },
  ];

  get departures() {
    return departureStore.departures;
  }

  get ocorrencias() {
    return reestruturacaoOcorrenciaStore.ocorrencias;
  }

  public getDescricaoObjetivo(objetivoId) {
    for (const objetivo of this.objetivos) {
      if (objetivo.id === objetivoId) {
        return objetivo.label;
      }
    }

    return '';
  }

  public editReestruturacaoOcorrencia(item) {
    this.id = item.id || 0;
    this.companyId = item.company_id;
    this.departureId = item.departure_id;
    this.tipoContato = item.tipo_contato;
    this.objetivoId = item.objetivo;
    this.observacao = item.observacao;
    item.departure_id;

    if (item.data_proximo_contato && item.data_proximo_contato != '') {
      this.dataProximoContato = item.data_proximo_contato.split('T')[0];
    }
  }

  public async deleteReestruturacaoOcorrencia({ id }) {
    this.$swal({
      title: 'Confirma a exclusão do item?',
      text: 'Após a exclusão do arquivo o mesmo não poderá ser recuperado!',
      icon: 'warning',
      showCancelButton: true,
      cancelButtonText: 'Cancelar',
      confirmButtonText: 'Sim, eu confirmo!',
    }).then(async (result) => {
      if (result.isConfirmed) {
        await reestruturacaoOcorrenciaStore.deleteReestruturacaoOcorrencia(id);

        await this.loadGrid();
      }
    });
  }

  public async resetForm() {
    this.id = 0;
    this.tipoContato = '';
    this.departureId = 0;
    this.objetivoId = 0;
    this.dataProximoContato = '';
    this.observacao = '';
  }

  public async handleSubmit() {
    this.loadingActionSubmit = true;

    const payload: IReestruturacaoOcorrencia = {
      company_id: this.companyId,
      tipo_contato: this.tipoContato,
      departure_id: this.departureId,
      objetivo: this.objetivoId,
      data_proximo_contato: this.dataProximoContato,
      observacao: this.observacao,
    };

    if (this.id > 0) {
      const updateReestruturacaoOcorrencia: IReestruturacaoOcorrenciaUpdate = {
        ...payload,
        id: this.id,
      };

      await reestruturacaoOcorrenciaStore.updateReestruturacaoOcorrencia({
        values: updateReestruturacaoOcorrencia,
      });
    } else {
      const newReestruturacaoOcorrencia: IReestruturacaoOcorrenciaCreate = {
        ...payload,
      };

      await reestruturacaoOcorrenciaStore.createReestruturacaoOcorrencia({
        ...newReestruturacaoOcorrencia,
      });
    }

    await this.loadGrid();
    this.resetForm();

    this.loadingActionSubmit = false;
  }

  public async handleDownloadComprovante({ download_url }) {
    if (download_url != '') window.open(download_url);
  }

  public async handleUploadComprovante(file, item) {
    if (Boolean(file)) {
      let formData = new FormData();
      formData.append('file', file);

      if (Boolean(item.download_url)) {
        this.$swal({
          title: 'Confirma a TROCA do comprovante?',
          text: 'Após a troca o comprovante anterior será excluído!',
          icon: 'warning',
          showCancelButton: true,
          cancelButtonText: 'Cancelar',
          confirmButtonText: 'Sim, eu confirmo!',
        }).then(async (result) => {
          if (result.isConfirmed) {
            await reestruturacaoOcorrenciaStore.uploadComprovanteReestruturacaoOcorrencia({
              id: item.id,
              file: formData,
            });

            await this.loadGrid();
          }
        });
      } else {
        await reestruturacaoOcorrenciaStore.uploadComprovanteReestruturacaoOcorrencia({
          id: item.id,
          file: formData,
        });

        await this.loadGrid();
      }
    }
  }

  public async loadGrid() {
    if (this.companyId > 0) await reestruturacaoOcorrenciaStore.getReestruturacaoOcorrencias(this.companyId);
  }

  public async load() {
    this.loading = true;

    await departureStore.getDepartureByIds([2, 5, 9, 11, 47]);
    await this.loadGrid();

    this.loading = false;
  }
}
